// AccessTier — feature gating + per-tier rate limits live here. S-053 reads
// this off AuthenticatedUser; admin assignment is on Tenant.
import { z } from "zod";
export const AccessTierSchema = z.enum(["basic", "professional", "enterprise"]);
export const ACCESS_TIERS = AccessTierSchema.options;
//# sourceMappingURL=AccessTier.js.map